import { render, staticRenderFns } from "./ButtonUpload.vue?vue&type=template&id=33fd9056&scoped=true&"
import script from "./ButtonUpload.vue?vue&type=script&lang=js&"
export * from "./ButtonUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fd9056",
  null
  
)

export default component.exports